import React from 'react';
import Box from '@mui/material/Box';
import {LinearProgress, Paper, Typography} from '@mui/material';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';

const spinSx = {
    fontSize: 16,
    animation: 'spin 1.5s linear infinite',
    '@keyframes spin': {from: {transform: 'rotate(0deg)'}, to: {transform: 'rotate(360deg)'}},
};

/**
 * Bannière affichée pendant le traitement (groupement par adresse, calcul des colonnes).
 */
export function ProcessingPanel() {
    return (
        <Paper elevation={0} sx={{
            mt: 3, mx: 2, px: 2.5, py: 2, borderRadius: 2,
            border: '1px solid', borderColor: 'divider',
            display: 'flex', flexDirection: 'column', gap: 1,
        }}>
            <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                <HourglassEmptyIcon sx={{...spinSx, color: 'warning.main'}}/>
                <Typography variant="body2" fontWeight="bold" color="text.secondary">
                    Traitement des données…
                </Typography>
                <Typography variant="caption" color="text.disabled" sx={{ml: 'auto'}}>
                    Groupement par adresse · Calcul des colonnes
                </Typography>
            </Box>
            <LinearProgress sx={{
                borderRadius: 4, height: 6,
                '& .MuiLinearProgress-bar': {bgcolor: 'warning.main'},
            }}/>
        </Paper>
    );
}

/**
 * Bannière affichée pendant l'initialisation du tableau (rendu DataGrid).
 * @param {{ rowsCount: number, columnsCount: number }} props
 */
export function TableLoadingPanel({rowsCount, columnsCount}) {
    return (
        <Paper elevation={0} sx={{
            mt: 3, mx: 2, px: 2.5, py: 2, borderRadius: 2,
            border: '1px solid', borderColor: 'divider',
            display: 'flex', flexDirection: 'column', gap: 1,
        }}>
            <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                <HourglassEmptyIcon sx={{...spinSx, color: 'primary.main'}}/>
                <Typography variant="body2" fontWeight="bold" color="text.secondary">
                    Chargement du tableau…
                </Typography>
                <Typography variant="caption" color="text.disabled" sx={{ml: 'auto'}}>
                    {rowsCount} adresse(s) · {columnsCount} colonnes
                </Typography>
            </Box>
            <LinearProgress sx={{borderRadius: 4, height: 6}}/>
        </Paper>
    );
}

